import type { FreeTrial as FreeTrialApi } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'
import { FREE_TRIAL_I18N_NAMESPACE, i18nInstance } from '../i18n'

const NO_TRIAL = {
  id: '',
  eligible: false,
  advocate: null,
  durationDays: 0,
  termsLink: '/',
  isPartnershipTrial: false,
  isGuestPass: false,
  freeTrialType: undefined,
  partnership: undefined,
  partnerInfo: undefined,
  strings: { duration: '', durationShort: '', type: '' },
}

export const useFreeTrial = ({ isGift }: { isGift?: boolean } = {}) => {
  const { trial } = useStaticData<{
    trial?: FreeTrialApi
  }>()

  // If user is gifting in checkout, we should not show trial info
  if (isGift || !trial) {
    return { trial: NO_TRIAL }
  }

  return {
    trial: {
      ...(trial ?? NO_TRIAL),
      strings: getTrialStrings(trial),
    },
  }
}

const getTrialStrings = (trial: FreeTrialApi) => {
  const t = i18nInstance.getFixedT(null, FREE_TRIAL_I18N_NAMESPACE)
  const durationDays = trial?.durationDays ?? 0

  let key = 'days'
  if (durationDays <= 1) key = 'hours'
  if (durationDays % 30 === 0) key = 'months'

  const durationNumber =
    durationDays % 30 === 0 ? durationDays / 30 : durationDays

  return {
    duration: t(`common.duration.${key}`, { count: durationNumber }),
    durationShort: t(`common.duration.short.${key}`, {
      count: durationNumber,
    }),
    type: trial.partnership
      ? t('freeTrial.labels.base')
      : t('guestPass.labels.base'),
  }
}
